import { useContext } from "react";
import styles from "./tableheader.module.css";
import { Button, Col, Divider, Input, Row, PageHeader } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { DataTableContext } from "../../context/DataTableContext";
import { FormFields } from "../PageData";

const { Search } = Input;

export interface Props {
  formFields?: FormFields[];
  selectedRowKeys: string[];
  refetch: any;
  useAdd: any;
  hasSelected: boolean;
  title: string;
  hasDelete?: boolean;
  hasCreate?: boolean;
  useRemoveMutation: any;
  modify: boolean;
}

function Header({
  selectedRowKeys,
  hasSelected,
  title,
  hasDelete,
  hasCreate,
  modify,
}: Props) {
  const handleAddNew = () => {
    setVisible(true);
  };
  const handleDelete = () => {
    setDeleteModalVisible(true);
  };
  const handleSearch = (value: string) => {
    setSearch(value);
  };
  const { setVisible, setDeleteModalVisible, setSearch, setIds } =
    useContext(DataTableContext);
  return (
    <>
      <PageHeader title={`${title}`} className={styles.title} />
      <Row className={styles.row}>
        <Col>
          <Search
            placeholder="Search"
            onSearch={handleSearch}
            allowClear
            className={styles.search}
          />
        </Col>
        <Col className={styles.modifyBtns}>
          {hasCreate && (
            <Button
              icon={<PlusOutlined />}
              type="primary"
              onClick={handleAddNew}
              className={styles.modifyBtn}
            >
              <span className={styles.modifyBtnText}>Add New</span>
            </Button>
          )}

          {hasDelete && (
            <Button
              icon={<DeleteOutlined />}
              disabled={!hasSelected}
              className={styles.modifyBtn}
              onClick={() => {
                setIds(selectedRowKeys);
                handleDelete();
              }}
            >
              <span className={styles.modifyBtnText}>Delete</span>
            </Button>
          )}
        </Col>
      </Row>
      <Divider />
    </>
  );
}

export default Header;
